import * as React from 'react';
import './home.css';
import { ResetButton } from './resetButton';
import { Palette } from './palette';
import { HybridizeButton } from './hybridizeButton';
import { Goal } from './goal';
import { PlayGuide } from './playGuide/playGuide';
import { HelpButton } from './helpButton';
import { AtomCounter } from './atomCounter';
import OptionsPanel from './options/optionsPanel';
import Params from '../options/Params';


const presentMode = <div className="user-interface">
	<div className="upper-left">
		<ResetButton />
	</div>
	<HybridizeButton />
</div>

const authorMode = <div className="user-interface">
	<div className="upper-left">
		<ResetButton />
	</div>
	<AtomCounter />
	<HybridizeButton />
	<Palette />
	<OptionsPanel />
</div>

const assessMode = <div className="user-interface">
	<PlayGuide />
	<div className="upper-left">
		<Goal />
		<ResetButton />
	</div>
	<HelpButton />
	<HybridizeButton />
	<Palette />
</div>

const exploreMode = <div className="user-interface">
	<PlayGuide />
	<div className="upper-left">
		<ResetButton />
	</div>
	<AtomCounter />
	<HelpButton />
	<HybridizeButton />
	<Palette />
</div>

export class UserInterface extends React.Component<{}, {}> {
	mode: string;

	constructor(props: Readonly<{}>) {
		super(props);

		this.mode = Params.mode;
		this.state = {
			playGuideOpen: true
		};
	}

	public render() {
		if (this.mode === 'present') {
			return presentMode;
		} else if (this.mode === "author") {
			return authorMode;
		} else if (this.mode === "assess") {
			return assessMode;
		} else {
			return exploreMode;
		}
	}
}